module.exports = __webpack_public_path__ + "assets/img/BestInnovative.ae7964f6.png";